const VESTA_MEGA_CLOSE_ANIM_MS = 850;

const VestaMegaCoordinator = (() => {
  let openInstance = null;
  let closeTimer = null;
  let scrimEl = null;
  // Tolerant enough for slow diagonal moves across the gap between the
  // top-level trigger and the panel, without feeling laggy on exit.
  const CLOSE_DELAY = 300;

  function getScrim() {
    if (scrimEl) return scrimEl;
    scrimEl = document.querySelector('[data-vesta-scrim]');
    if (scrimEl) {
      scrimEl.addEventListener('mouseenter', scheduleClose);
      scrimEl.addEventListener('click', closeNow);
    }
    return scrimEl;
  }

  function open(instance) {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (openInstance && openInstance !== instance) {
      openInstance.startCloseAnimation();
    }
    openInstance = instance;
    instance.forceOpen();
    getScrim();
    document.body.classList.add('vesta-menu-open');
  }

  function scheduleClose() {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(closeNow, CLOSE_DELAY);
  }

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeNow() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (openInstance) {
      openInstance.startCloseAnimation();
      openInstance = null;
    }
    document.body.classList.remove('vesta-menu-open');
  }

  function dropInstance(instance) {
    if (openInstance === instance) closeNow();
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openInstance) closeNow();
  });

  return { open, scheduleClose, cancelClose, closeNow, dropInstance };
})();

class MegaMenuHover extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.header = document.querySelector('.header-wrapper');

    this.setupEvents();
  }

  disconnectedCallback() {
    VestaMegaCoordinator.dropInstance(this);
  }

  setupEvents() {
    this.addEventListener('mouseenter', () => VestaMegaCoordinator.open(this));
    this.addEventListener('mouseleave', () => VestaMegaCoordinator.scheduleClose());
    // Re-open (not just cancel) when the pointer reaches the panel: a close
    // animation may already have started while crossing the gap between the
    // trigger and the panel, and cancelClose alone can't abort it.
    this.content.addEventListener('mouseenter', () => VestaMegaCoordinator.open(this));

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onSummaryClick(event) {
    const mainLink = event.currentTarget.querySelector('.mega-menu__main-link');
    if (mainLink && event.target.closest('.mega-menu__main-link')) {
      event.preventDefault();
      window.location.href = mainLink.getAttribute('href');
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) VestaMegaCoordinator.scheduleClose();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open');
  }

  forceOpen() {
    if (this.closeAnimTimer) {
      clearTimeout(this.closeAnimTimer);
      this.closeAnimTimer = null;
    }
    this.mainDetailsToggle.classList.remove('is-closing');
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  startCloseAnimation() {
    if (this.closeAnimTimer) clearTimeout(this.closeAnimTimer);
    this.mainDetailsToggle.classList.add('is-closing');
    this.summary.setAttribute('aria-expanded', 'false');
    this.closeAnimTimer = setTimeout(() => {
      this.closeAnimTimer = null;
      this.mainDetailsToggle.classList.remove('is-closing');
      this.mainDetailsToggle.removeAttribute('open');
    }, VESTA_MEGA_CLOSE_ANIM_MS);
  }

  forceClose() {
    if (this.closeAnimTimer) {
      clearTimeout(this.closeAnimTimer);
      this.closeAnimTimer = null;
    }
    this.mainDetailsToggle.classList.remove('is-closing');
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('mega-menu-hover', MegaMenuHover);
